import { ApolloLink } from 'apollo-link';
import { cloneDeep } from 'lodash';

const TYPENAME_STRING = '__typename';

const isObject = (obj: unknown) => !!obj && typeof obj === 'object';
const objectProperties = (obj: object) => Object.getOwnPropertyNames(obj);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stripTypenames(obj: Record<string, any>): void {
  if (Array.isArray(obj)) {
    obj.forEach(o => stripTypenames(o));
  } else {
    objectProperties(obj).forEach(property => {
      if (isObject(obj[property])) {
        stripTypenames(obj[property]);
      } else {
        if (property === TYPENAME_STRING) {
          delete obj[property];
        }
      }
    });
  }
}

export default new ApolloLink((operation, forward) => {
  if (isObject(operation.variables)) {
    // Clone the variables, because stripTypenames edits the object in place
    operation.variables = cloneDeep(operation.variables);
    stripTypenames(operation.variables);
  }

  return forward(operation);
});
